export const START_DOWNLOAD = 'START_DOWNLOAD';
export const STOP_DOWNLOAD = 'STOP_DOWNLOAD';

export const startDownload = (docIds) => ({
  type: START_DOWNLOAD,
  payload: docIds,
});

export const stopDownload = () => ({
  type: STOP_DOWNLOAD,
});
